/**
 * Pure validator for the `next` URL parameter used by `<RequireAuth>` →
 * `/login?next=…` deep-link preservation.
 *
 * Whitelist-Approach: only relative paths under `/dashboard` or `/admin` as a
 * whole path segment pass. Blocks protocol-relative URLs (`//evil.com`),
 * absolute URLs (`https://…`), `javascript:` URIs, backslash-smuggling
 * (Windows-Path), and prefix-spoofing (`/dashboard-evil`).
 */
export function isValidNextPath(next: string | null | undefined): next is string {
  if (!next || typeof next !== 'string') return false;
  if (next.startsWith('//')) return false;
  if (next.includes('\\')) return false;
  if (!next.startsWith('/')) return false;
  return /^\/(dashboard|admin)(\/|$|\?)/.test(next);
}

/**
 * Student variant of {@link isValidNextPath}: only relative paths under
 * `/student` pass. Same whitelist hardening (no protocol-relative, absolute,
 * backslash, or prefix-spoofing like `/student-evil`).
 */
export function isValidStudentNextPath(next: string | null | undefined): next is string {
  if (!next || typeof next !== 'string') return false;
  if (next.startsWith('//')) return false;
  if (next.includes('\\')) return false;
  if (!next.startsWith('/')) return false;
  return /^\/student(\/|$|\?)/.test(next);
}
